import { formatCents } from '@packages/shared';
import { Link, useParams } from '@tanstack/react-router';
import { ActionButton } from '@/components/ui+/ActionButton';
import type { SiteData } from '../SiteCheckInLayout';

export const WelcomeContent = ({
  siteWrap,
  siteCode,
}: {
  siteWrap: SiteData;
  siteCode: string;
}) => {
  const { companyLocationCode } = useParams({ from: '/$companyLocationCode/$siteCode' });

  return (
    <div className="flex flex-1 flex-col">
      <div className="space-y-6">
        <div className="rounded-2xl border bg-card p-5">
          <div className="flex flex-col items-center space-y-1 text-center">
            <h2 className="text-2xl font-bold tracking-tight">Site {siteCode}</h2>
          </div>

          <div className="mt-5 flex items-center gap-2 rounded-lg bg-muted px-4 py-2.5">
            <img src="/logo-only.png" alt="Orto-Mate" className="size-4" />
            <span className="text-xs">Metering by Orto-Mate</span>
          </div>

          <div className="mt-5 grid grid-cols-2 gap-y-4">
            <div>
              <p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
                Site Code
              </p>
              <p className="text-sm font-bold">{siteCode}</p>
            </div>
            <div>
              <p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
                Meter
              </p>
              <p className="text-sm font-bold">Shore Power {siteCode}</p>
            </div>
            <div>
              <p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
                Rate
              </p>
              <p className="text-sm font-bold">
                {formatCents(siteWrap.electricityUnitPrice, '$')}/kWh
              </p>
            </div>
            <div>
              <p className="text-[10px] font-semibold uppercase tracking-wider text-muted-foreground">
                Pre-Auth Hold
              </p>
              <p className="text-sm font-bold">$100.00</p>
            </div>
          </div>
        </div>
      </div>

      <div className="mt-6 space-y-6">
        <ActionButton asChild size="lg" className="w-full">
          <Link
            to="/$companyLocationCode/$siteCode/register"
            params={{ companyLocationCode, siteCode }}
          >
            Start registration
          </Link>
        </ActionButton>

        <div className="space-y-1 text-center">
          <p className="text-xs text-muted-foreground">Need help? Contact 08 9938 0437</p>
          <p className="text-xs text-muted-foreground">Orto-Mate Pay {__COMMIT_SHA__}</p>
        </div>
      </div>
    </div>
  );
};
